import React from "react";
import DepositTransfersTable from "./DepositTransfersTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const DepositTransfersIndex = () => (
  <ReportProgramsPage
    TableComponent={DepositTransfersTable}
    loadingMessage="Loading deposit transfers..."
  />
);

export default DepositTransfersIndex;
